import React from 'react';

import LiveAssistFrame from 'components/Alpha/LiveAssist/LiveAssistFrame';
import LiveAssistPanel from 'components/Alpha/LiveAssist/LiveAssistPanel';
import {
  LiveCallScribeCallSelector,
  useLiveAssistTarget,
} from 'components/Alpha/LiveAssist/liveAssistTarget';
import CallScribeWindow from 'components/CallScribe/Window/CallScribeWindow';
import { useAppSelector } from 'hooks/store';
import { CallScribeActiveTranscriptCallSelector } from 'store/callScribe/selectors';

const CallScribeWindowHost: React.FC = () => {
  const liveCallId = useAppSelector(LiveCallScribeCallSelector);
  const shownCallId = useAppSelector(CallScribeActiveTranscriptCallSelector);
  const target = useLiveAssistTarget(liveCallId, shownCallId, true);
  return (
    <LiveAssistFrame>
      <CallScribeWindow />
      <LiveAssistPanel callId={target.callId} mode={target.mode} attempt={target.attempt} />
    </LiveAssistFrame>
  );
};

export default CallScribeWindowHost;
